import { render, staticRenderFns } from "./APdf.vue?vue&type=template&id=1b23e930&"
import script from "./APdf.vue?vue&type=script&lang=js&"
export * from "./APdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports